export const baseApiUrl='https://ipe-clube-estacionamento-534bfa544275.herokuapp.com/api'
export const userKey = '{"usuario": "PortalIpeVagas", "senha": "2b7b3ef312689e2e7e92a73bd5077fa6"}'